// How many times a GIF in the message list plays before it stops (#489): Once, 3 times (the default) or Forever.
// Remembered on this device only, like the layout (layout.ts); Settings → Appearance → GIF plays changes it, and it
// applies at once. Storage can be missing or throw (private windows, blocked site data): then the choice lasts until
// reload.
import { useSyncExternalStore } from "react";
import { parseGifPlays, type GifPlays } from "@bloom/shared";

export const GIF_PLAYS_KEY = "bloom:gif-plays";

function stored(): GifPlays {
  try {
    return parseGifPlays(localStorage.getItem(GIF_PLAYS_KEY));
  } catch {
    return parseGifPlays(null);
  }
}

const listeners = new Set<() => void>();
let current: GifPlays = stored();

export const getGifPlays = () => current;

export function setGifPlays(next: GifPlays) {
  if (parseGifPlays(next) !== next) return;
  current = next;
  try {
    localStorage.setItem(GIF_PLAYS_KEY, next);
  } catch {
    // private mode: still applies for this page
  }
  for (const fn of listeners) fn();
}

// Another tab changed it.
addEventListener("storage", (e) => {
  if (e.key !== GIF_PLAYS_KEY) return;
  current = stored();
  for (const fn of listeners) fn();
});

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const useGifPlays = (): GifPlays => useSyncExternalStore(subscribe, getGifPlays);
